import {
  dbui_v1_ObservableTop10List,
  dbuiV1GetObservableTop10Options,
  dbuiV1GetObservableTop10QueryKey,
} from '@antimatterhq/asl-api-ts-v1';
import { useQueryClient } from '@tanstack/react-query';
import { useQuery } from '@antimatterhq/ui/hooks/queries/useQuery';
import { useValueWithSuspense } from '@antimatterhq/ui/hooks/suspense/useValueWithSuspense';
import { useWarehouseLocation } from '@/contexts/WarehouseLocationContext';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export const useGetObservablesTop10 = () => {
  const workspaceContext = useWorkspace();
  const warehouseLocationContext = useWarehouseLocation();
  const workspace = useValueWithSuspense(workspaceContext.workspace);
  const selectedWarehouse = useValueWithSuspense(
    warehouseLocationContext.selectedWarehouse,
  );

  return useQuery({
    ...dbuiV1GetObservableTop10Options({
      ...defaultOptions(),
      path: { workspace },
      query: { warehouse: selectedWarehouse?.id || '' },
    }),
  });
};

export const useOptimisticUpdateObservablesTop10 = () => {
  const { workspace } = useWorkspace();
  const { selectedWarehouse } = useWarehouseLocation();
  const warehouse = selectedWarehouse?.id || '';
  const queryClient = useQueryClient();

  return (top10List: dbui_v1_ObservableTop10List) => {
    queryClient.setQueryData(
      dbuiV1GetObservableTop10QueryKey({
        ...defaultOptions(),
        path: { workspace },
        query: { warehouse },
      }),
      top10List,
    );
  };
};

export const useClearCacheObservablesTop10 = () => {
  const queryClient = useQueryClient();
  const { workspace } = useWorkspace();
  const { selectedWarehouse } = useWarehouseLocation();
  const warehouse = selectedWarehouse?.id || '';
  return () => {
    queryClient.removeQueries({
      queryKey: dbuiV1GetObservableTop10QueryKey({
        ...defaultOptions(),
        path: { workspace },
        query: { warehouse },
      }),
      exact: false,
    });
  };
};
